<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="150px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="推送人姓名/联系电话"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.keyword"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="小区名称"
                prop="ridgepoleId"
                label-width="70px"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.villageId"
                  placeholder="请选择小区"
                  @change="villageSelect"
                >
                  <el-option
                    v-for="item in villageList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="楼栋名称"
                prop="ridgepoleId"
                label-width="70px"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.ridgepoleId"
                  placeholder="请选择楼栋"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="单元名称"
                prop="ridgepoleId"
                label-width="70px"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.unitId"
                  placeholder="请选择单元"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="楼层名称"
                prop="name"
                label-width="70px"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.floorId"
                  placeholder="请选择楼层"
                  @change="floorSelect"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="房间名称"
                prop="name"
                label-width="70px"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.roomId"
                  placeholder="请选择房间"
                >
                  <el-option
                    v-for="item in roomList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
           
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-download"
          @click="download"
          >导出记录</el-button>
        <el-button
          size="small"
          type="danger"
          icon="el-icon-delete"
          @click="batchDel"
          >批量删除</el-button>
      </div>

      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        @selection-change="handleSelectionChange"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column prop="address" label="房屋信息" align="center">
        </el-table-column>
        <el-table-column prop="cycleStartTime" label="缴费周期" align="center">
          <template slot-scope="scope">
            {{ scope.row.cycleStartTime.split(' ')[0] }}-{{ scope.row.cycleEndTime.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="缴费类型" align="center">
        </el-table-column>
        <el-table-column prop="userNames" label="推送人姓名" align="center">
        </el-table-column>
        <el-table-column prop="phones" label="联系电话" align="center">
        </el-table-column>
        <el-table-column prop="billPrice" label="缴费金额" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="账单生成时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      isAddModal: false,
      btnLoading: false,
      isAddModals: false,
      personList: [],
      addData: {
        manageUserId:"",
        subscribeTime:""
      },
      searchForm: {
        keyword: "",
        villageId:'',
        floorId:'',
        unitId:'',
        ridgepoleId:'',
        roomId:''
      },
      addDataRules: {
        
      },
      personList: [],
      diaTitle:'详情',
      ridgepoleList: [],
      villageList:[],
      unitList: [],
      floorList: [],
      roomList: [],
    };
  },
  mounted() {
    this.onLoad();
    this.$Apis.villageListAll().then(res=>{
      if (res.code == 200) {
        this.villageList = res.data;
      }
    })
  },
  methods: {
    download(){
      this.$Apis.getExportCode().then(res=>{
        if(res.code == 200){
          window.location.href = process.env.VUE_APP_UPLOAD_REAL_PATH + '/export/notPayBill?uCode=' + res.data + '&keyword=' + this.searchForm.keyword + '&villageId=' + this.searchForm.villageId + '&ridgepoleId=' + this.searchForm.ridgepoleId + '&unitId=' + this.searchForm.unitId + '&floorId=' + this.searchForm.floorId + '&status=0'
        }
      })
    },
    villageSelect(e,row){
      this.$Apis.houseAllList({
        villageId: e,
        noData:1
      }).then((res) => {
        if (res.code == 200) {
          this.ridgepoleList = res.data;
          this.searchForm.ridgepoleId = ''
          this.searchForm.unitId = ''
          this.searchForm.floorId = ''
          this.searchForm.roomId = ''
        }
      });
    },
    ridgepoleSelect(e,row) {
      this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
        if (res.code == 200) {
          this.searchForm.unitId = ''
          this.searchForm.floorId = ''
          this.searchForm.roomId = ''
          this.unitList = res.data;
        }
      });
    },
    // 选择单元
    unitSelect(e, row) {
      this.$Apis.floorAllList({ unitId: e }).then((res) => {
        if (res.code == 200) {
          this.floorList = res.data;
          this.searchForm.floorId = ''
          this.searchForm.roomId = ''
        }
      });
    },
    //选择楼层
    floorSelect(e,row){
      this.$Apis.roomAllList({ floorId: e }).then((res) => {
        if (res.code == 200) {
          this.roomList = res.data;
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
   
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
        status:0
      };
      this.tableData = [];
      this.$Apis.billList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
      
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.billDel({ ids:id }).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    batchDel(){
      let arrId = this.multipleSelection;
      if(arrId.length == 0){
        this.$message.warning('请选择要删除的记录');
        return;
      }
      this.$confirm("您确定要删除选中的记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.billDel({ ids: arrId.join(',') }).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$refs.multipleTable.clearSelection();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    // 全选
    handleSelectionChange(e){
      var arrId = [];
      if (e.length > 0) {
        e.forEach((res) => {
          arrId.push(res.id);
        });
      }
      this.multipleSelection = arrId;
    },
    
  },
};
</script>

<style  scoped>
/deep/.el-input.is-disabled .el-input__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
.flex{
  display: flex;
  align-items: center;
  height: 40px;
}
.main{
  padding-top: 30px;
  border-top: 1px solid #eee;
}
.mtitle{
  font-size: 18px;
  /* padding-left: 40px; */
  font-weight: bold;

}
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>